import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getDurationsSummaryInfo } from 'src/components/oneCorp/features/MealCredit/utils/getDurationsSummaryInfo';
import { getDurationMinutes } from 'src/components/oneCorp/features/MealCredit/utils/mealCreditDurationsCalculations.utils';

export interface UseGetDurationsSubheader {
  subheader: string;
}

export const useGetDurationsSubheader = (): UseGetDurationsSubheader => {
  const { errors } = useFormContext<IMealCreditFormFields>();
  const { formValues } = useMealCreditFormData();
  const {
    selectedDays,
    budgetResetPeriod,
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    isMonthAvailable,
    budgetLength,
    budgetResetType,
    isRepeating,
    startDate,
    expirationDate,
    numberOfConsecutiveDays,
    numberOfConsecutiveMonths,
    endTimeFullDate,
    expiresOn,
    timeIntervalType,
    startTime,
    startTimeMeridian,
    endTime,
    endTimeMeridian,
    monthAvailableTo,
    monthAvailableOn,
  } = formValues;

  const durationMinutes = getDurationMinutes({
    timeIntervalType,
    startTime,
    startTimeMeridian,
    endTime,
    endTimeMeridian,
  });

  const subheader = getDurationsSummaryInfo({
    isDailyLengthBudget,
    isWeeklyLengthBudget,
    isMonthlyLengthBudget,
    isMonthAvailable,
    budgetLength,
    isRepeating,
    startDate,
    endTimeFullDate,
    selectedDays,
    budgetResetType,
    budgetResetPeriod: Number(budgetResetPeriod),
    expirationDate,
    expiresOn,
    timeIntervalType,
    refreshPeriodDaysCount: numberOfConsecutiveDays,
    refreshPeriodMonthsCount: numberOfConsecutiveMonths,
    errors,
    durationMinutes,
    monthAvailableTo,
    monthAvailableOn,
  });

  return {
    subheader,
  };
};
